import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DocumentEditPopupComponent } from '../document-edit-popup/document-edit-popup.component';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import {
  AttachDocumentBtn,
  Column,
  DOWNLOAD_DISABLED_USER_ROLES_FOR_RMREVIEWED_DOCUMENT,
  toast,
  ToggleGroupOptions,
  ToggleOptions,
} from './document-table-settings';
import { ToggleComponent } from '@usitsdasdesign/dds-ng/toggle';
import { SubmissionService } from '../../../../../../http/intake/submission.service';
import { Subject, takeUntil } from 'rxjs';
import { ProgressIndicatorService } from '../../../../../../common/services/progress-indicator.service';
import {
  DocumentTriggerSubjectModel,
  IntakeDocumentTableModel,
} from '../../../../../../common/models/intake-document-table.model';
import { DocumentService } from '../../../../../../http/document/document.service';
import {
  IntakeConstant,
  IntakeDocTableIdMapper,
  VALID_DOCUMENT_TYPES,
} from '../../../../../constants/intake.constant';
import { IntakeDocumentSubmissionTypeCode } from '../../../../../constants/intake-submission-type.enum';
import { StatusEnum } from '../../../../../../common/constants/status-enum';
import { IntakeOppertunitySubmissionStatus } from '../../../../../constants/intake-submission-status.enum';
import { ToastService } from '@usitsdasdesign/dds-ng/toast';
import { RoleEnum } from '../../../../../constants/Role.enum';
import {
  DocumentArchivalStatus,
  DocumentStatus,
  draftDocStatus,
  IntakeDocumentStatusIdMapper,
} from '../../../../../constants/document-status.enum';
import {
  CheckboxGroupOptions,
  CheckboxOptions,
} from '@usitsdasdesign/dds-ng/checkbox';
import {
  Themes,
  ErrorState,
  ButtonKind,
  ExtThemes,
} from '@usitsdasdesign/dds-ng/shared';
import { TooltipOptions } from '@usitsdasdesign/dds-ng/tooltip';
import { tooltipOptionsData } from '../../../../opportunity-details-settings';
import { RoleService } from '../../../../../../http/intake/role.service';
import { ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { HttpErrorResponse } from '@angular/common/http';
import { PermissionsObj } from '../../../../../../common/models/common-models';
import { OpportunityDetailsNavModel } from '../../../../../../common/models/opportunity-details.model';
import { isTheDocumentHasCompletedElSOw } from '../../../../../common/intake.util';
import { compareDates } from '../../../../../../common/utils/common-util';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';

@Component({
  selector: 'app-document-table',
  templateUrl: './document-table.component.html',
  styleUrl: './document-table.component.less',
})
export class DocumentTableComponent implements OnChanges, OnDestroy, OnInit {
  @Input() tableId!: number;
  @Input() submissionId: number = 0;
  @Input() submissionTypeId: number = 0;
  @Input() submissionStatusId: number = 0;
  @Input() isEditable: boolean = false;
  @Input() showArchiveIt: boolean = false;
  @Input() showToggleBtn: boolean = true;
  @Input() toggleOpen: boolean = false;
  @Input() filterDocArr: string[] = [];
  @Input() submissionStatus: string | undefined = IntakeConstant.EMPTY_SPACE;
  @Input() submissionTypeCode: string | undefined = IntakeConstant.EMPTY_SPACE;
  @Input() opportunityDocs!: OpportunityDetailsNavModel[];
  @Input() submissionTypeSubId: number | null | undefined = null;
  @Input() rmReviewedGuidanceNoteHeader: string = IntakeConstant.EMPTY_SPACE;
  @Input() rmReviewedGuidanceNoteBody: string = IntakeConstant.EMPTY_SPACE;
  @Input() optOutOfSelfReview: string | null | undefined =
    IntakeConstant.EMPTY_SPACE;
  @Input() currentStatusChangeDate: string | null = null;
  @Input() otherSubmissionSubType!: string;
  @Input() documentTypeOptions: SelectItemOptions[] = [];
  @Input() documentStatusOptions: SelectItemOptions[] = [];

  loggedInUserRoles: string[] = [];
  @Input() set progressiveStatus(status: boolean | null) {
    setTimeout(() => {
      if (status != null) {
        this.updateServerValue(status);
      }
    }, 150);
  }
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Output() documentTableData: EventEmitter<IntakeDocumentTableModel[]> =
    new EventEmitter<IntakeDocumentTableModel[]>();

  private readonly unsubscriber$: Subject<void> = new Subject<void>();
  groupOptions = ToggleGroupOptions;
  @ViewChild('toggle', { static: false })
  toggle!: ToggleComponent;
  options = ToggleOptions;
  docToShow: IntakeDocumentTableModel[] = [];
  public docMetaData: IntakeDocumentTableModel[] = [];
  allDocFromAPI: IntakeDocumentTableModel[] = [];
  toasteOption = toast;
  public sampleColumns = Column;
  optionsToolTip: TooltipOptions = tooltipOptionsData;
  public readonly INTAKE = 'Intake';
  attachDocumentBtn = AttachDocumentBtn;
  isSubmissionStatusRMorSelfReviewed: boolean = false;

  allSelectedDocTypeSupporting: boolean = true;
  downloadDisabledUserRolesForRMReviewedDocs: string[] =
    DOWNLOAD_DISABLED_USER_ROLES_FOR_RMREVIEWED_DOCUMENT;
  downloadButtonDisabled: boolean = false;
  disabledDocumentIdList: number[] = [];
  tableIdMapper: { [key: string]: number } = IntakeDocTableIdMapper;
  docArchivalStatus = DocumentArchivalStatus;
  submissionStatusCompletedOrCompletedAdmin: boolean = false;
  submissionStatusCompleted = IntakeOppertunitySubmissionStatus.COMPLETED;
  submissionStatusCompletedAdmin =
    IntakeOppertunitySubmissionStatus.COMPLETED_ADMIN;

  rm_reviewed_doc_status_allowed_roles: string[] = [
    RoleEnum.RISK_MANAGER,
    RoleEnum.SUPPORTING_RISK_MANAGER,
    RoleEnum.SPECIALIZED_RISK_MANAGER,
    RoleEnum.SYSTEM_ADMINISTRATOR,
    RoleEnum.SYSTEM_ADMINISTRATOR,
  ];
  constructor(
    private readonly modalService: ModalService,
    private readonly intakeDetailService: SubmissionService,
    private readonly progressIndicator: ProgressIndicatorService,
    private readonly documentService: DocumentService,
    private readonly toastService: ToastService,
    private readonly roleService: RoleService,
    private readonly submissionService: SubmissionService
  ) {}

  ngOnInit(): void {
    this.roleService.currentUserRole$
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: (response: string[]) => {
          this.loggedInUserRoles = response;
        },
      });

    this.intakeDetailService.triggerDocumentDataReload$
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe((data: DocumentTriggerSubjectModel | null) => {
        if (data) {
          if (
            data?.triggerScope === 'all' ||
            (data?.triggerScope === 'specific' &&
              data?.reloadTableId === this.tableId)
          ) {
            this.getDocumentMetaData();
          }
        }
      });

    this.isSubmissionStatusRMorSelfReviewed =
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.RM_REVIEWED_PENDING_CLOSEOUT ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.SELF_REVIEWED_PENDING_CLOSEOUT;
  }

  #updateStatus(): void {
    const validTypes =
      VALID_DOCUMENT_TYPES[
        this.submissionTypeCode as IntakeDocumentSubmissionTypeCode
      ];
    if (
      (this.submissionTypeCode as IntakeDocumentSubmissionTypeCode) ===
      IntakeDocumentSubmissionTypeCode.CO
    ) {
      //TODO: Need to check using global constant issues
      const isELSOWCompletedExist: boolean = isTheDocumentHasCompletedElSOw(
        this.opportunityDocs
      );
      const co_doc_status = this.docMetaData.some(
        (item: IntakeDocumentTableModel) =>
          item.documentType === 'Change Order' &&
          ((item.documentStatus as DocumentStatus) === DocumentStatus.Draft ||
            (item.documentStatus as DocumentStatus) ===
              DocumentStatus.SelfReviewed)
      );
      this.intakeDetailService.co_draft_availability.next(co_doc_status);
      if (isELSOWCompletedExist) {
        const status = this.docMetaData.some(
          (item: IntakeDocumentTableModel) =>
            item.documentType === 'Change Order' &&
            ((item.documentStatus as DocumentStatus) === DocumentStatus.Draft ||
              (item.documentStatus as DocumentStatus) ===
                DocumentStatus.SelfReviewed)
        );
        this.intakeDetailService.docISValid.next(status);
      } else {
        const hasExecutedDocument = this.docMetaData.some(
          (item: IntakeDocumentTableModel) =>
            item.documentType === IntakeConstant.EXECUTED_ENGAGEMENT_LETTER &&
            item.documentStatus === DocumentStatus.SupportingDocument
        );
        const status = co_doc_status && hasExecutedDocument;
        this.intakeDetailService.docISValid.next(status);
      }
    } else if (
      (this.submissionTypeCode as IntakeDocumentSubmissionTypeCode) ===
        IntakeDocumentSubmissionTypeCode.OTH &&
      this.otherSubmissionSubType ===
        IntakeConstant.SUBCONTRACTOR_AGREEMENT_OTH_SUBTYPE
    ) {
      const status = this.docMetaData.some(
        (item: IntakeDocumentTableModel) =>
          item.documentType === IntakeConstant.SUBCONTRACTOR_AGREEMENT &&
          (item.documentStatus as DocumentStatus) === DocumentStatus.Draft
      );
      this.intakeDetailService.docISValid.next(status);
    } else {
      const status = this.docMetaData.some((item: IntakeDocumentTableModel) => {
        if (this.submissionStatusId === 1) {
          if (
            (this.submissionTypeCode as IntakeDocumentSubmissionTypeCode) ===
            IntakeDocumentSubmissionTypeCode.PRO
          ) {
            return (
              item.documentStatus === DocumentStatus.Draft ||
              item.documentStatus === DocumentStatus.SelfReviewed
            );
          }
          return (
            (validTypes.includes(item.documentType) &&
              item.documentStatus === DocumentStatus.Draft) ||
            item.documentStatus === DocumentStatus.SelfReviewed
          );
        } else {
          return validTypes.includes(item.documentType);
        }
      });
      this.intakeDetailService.docISValid.next(status);
    }
  }
  archiveItHeader: string = IntakeConstant.DOCUMENT_TABLE_ARCHIVE_HEADING;

  checkBoxGroupOptions: CheckboxGroupOptions = {
    title: IntakeConstant.EMPTY_SPACE,
    isRequired: false,
    isInverse: false,
  };

  checkBoxOptions: CheckboxOptions = {
    label: IntakeConstant.EMPTY_SPACE,
    theme: Themes.green,
    isIndeterminate: false,
    isError: false,
    isRequired: false,
    errorState: ErrorState.default,
    ariaLabel: 'checkbox',
    customClass: IntakeConstant.EMPTY_SPACE,
  };

  actionButtonOptions: ButtonOptions = {
    theme: ExtThemes.dark,
    kind: ButtonKind.silent,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['submissionId']?.currentValue) {
      this.getDocumentMetaData();
    }

    if (
      changes['submissionTypeSubId'] &&
      changes['submissionTypeSubId'].currentValue
    ) {
      this.submissionTypeSubId = changes['submissionTypeSubId'].currentValue;
    }

    if (changes['isEditable']) {
      if (!this.isEditable) {
        this.sampleColumns = this.sampleColumns.filter(
          (item) => item.name !== 'Actions'
        );
      } else {
        this.sampleColumns = Column;
      }
    }

    if (changes['submissionStatus']) {
      this.submissionStatusCompletedOrCompletedAdmin =
        this.submissionStatus === this.submissionStatusCompleted ||
        this.submissionStatus === this.submissionStatusCompletedAdmin;
    }
  }

  stateChanged(event: boolean): void {
    this.updateServerValue(event);
  }

  updateServerValue(event: boolean): void {
    this.filterDocumentData(event);
    if (this.toggleOpen !== event) {
      setTimeout(() => this.toggle?.toggleState(true), 100);
    }
  }

  updateToggleOption(): void {
    if (
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.RM_REVIEWED_PENDING_CLOSEOUT ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.SELF_REVIEWED_PENDING_CLOSEOUT
    ) {
      this.toggleOpen = true;
    } else if (this.toggleOpen) {
      this.toggleOpen = true;
    } else {
      this.toggleOpen = false;
    }
  }

  filterDocumentData(draftHidden: boolean): void {
    if (draftHidden) {
      this.docToShow = this.docMetaData.filter(
        (doc: any) =>
          ![
            DocumentStatus.Draft,
            DocumentStatus.SupportingDocument,
            DocumentStatus.SelfReviewed,
          ].includes(doc.documentStatus)
      );
    } else {
      this.docToShow = this.docMetaData;
    }
  }

  filterDocumentByDocStatus(filterDocStatusArr: string[]): any {
    this.docToShow = this.docMetaData.filter((doc: IntakeDocumentTableModel) =>
      filterDocStatusArr.includes(doc.documentStatus)
    );
  }

  onDownload(event: IntakeDocumentTableModel): void {
    if (this.permissionObj['Intake_Submission_DocumentDownload_Enable']) {
      if (event.archivalStatus == DocumentArchivalStatus.ARCHIVED) {
        if (event.attachmentId) {
          this.documentService
            .getArchivedDocDownloadUrl(event.attachmentId)
            .subscribe({
              next: (response: any) => {
                if (response?.documentDownloadUrl) {
                  window.open(response.documentDownloadUrl, '_blank');
                }
              },
              error: (err: Error) => {
                console.error('Error in downloading archived document', err);
              },
            });
        }
      } else {
        let downloadRequest = {
          DocumentName: event.documentTitle,
          DocumentKey: event.attachmentGuid,
          FileFolderPath: this.INTAKE,
          archivalStatus:
            event.archivalStatus == DocumentArchivalStatus.ARCHIVED,
        };
        this.documentService.getDownloadUrl(downloadRequest).subscribe({
          next: (response: any) => {
            if (response?.documentDownloadUrl) {
              window.open(response.documentDownloadUrl, '_blank');
            }
          },
          error: (err: HttpErrorResponse) => {
            console.error('Error in downloading document', err);
          },
        });
      }
    }
  }

  openLink(item: string): void {
    const finalUrl =
      item.startsWith('http://') || item.startsWith('https://')
        ? item
        : `https://${item}`;
    if (
      item &&
      this.permissionObj['Intake_Submission_DocumentDownload_Enable']
    ) {
      window.open(finalUrl, '_blank');
    }
  }

  onEdit(item: IntakeDocumentTableModel, modalBtn?: any): void {
    let filteredStatus = this.documentStatusOptions;
    if (!!item?.documentUrl) {
      console.log(item.documentUrl);
      filteredStatus = filteredStatus.filter(
        (item: SelectItemOptions) =>
          item.value !==
          IntakeDocumentStatusIdMapper.get(
            DocumentStatus.FinalArchiveReadyVersion
          )
      );
    }

    if (
      item.documentType !== DocumentStatus.RMReviewed &&
      !this.loggedInUserRoles.some((role: string) =>
        this.rm_reviewed_doc_status_allowed_roles.includes(role)
      )
    ) {
      filteredStatus = filteredStatus.filter(
        (item: SelectItemOptions) =>
          item.value !==
          IntakeDocumentStatusIdMapper.get(DocumentStatus.RMReviewed)
      );
    }

    const modalRef = this.modalService.open(DocumentEditPopupComponent, {
      isFooter: true,
      size: IntakeConstant.UI_ELEMENT_SIZE,
      isInverse: false,
      documentInitiatedDetails: {
        moduleName: this.INTAKE,
        submissionStatusId: this.submissionStatusId,
        submissionTypeId: this.submissionTypeId,
        comments: item.comments,
        submissionDocumentId: item.submissionDocumentId,
        documentTitle: item.documentTitle,
        documenturl: item.documentUrl,
        submissionDocumentTypeId: item.submissionDocumentTypeId,
        submissionId: this.submissionId,
        documentTypeId: item.documentTypeId,
        documentStatusId: item.documentStatusId,
        type: this.submissionTypeCode,
        attachmentId: item.attachmentId,
        documentTypeDropdownType: item.documentType,
        documentStatusDropdownType: item.documentStatus,
        submissionStatus: this.submissionStatus,
        submissionTypeCode: this.submissionTypeCode,
        submissionTypeSubId: this.submissionTypeSubId,
      },
      rmReviewedGuidanceNoteHeader: this.rmReviewedGuidanceNoteHeader,
      rmReviewedGuidanceNoteBody: this.rmReviewedGuidanceNoteBody,
      documentTypeOptions: this.documentTypeOptions,
      setDocumentStatusOptions: filteredStatus,
    });
    modalRef
      .onClosed()
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe(() => {
        this.triggerDocAPIReload();
        if (modalBtn) {
          modalBtn.focus();
        }
      });
  }

  onDelete(item: IntakeDocumentTableModel): void {
    if (
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.RM_REVIEWED_PENDING_CLOSEOUT &&
      !this.loggedInUserRoles.includes(RoleEnum.PERSUIT_TEAM) // TODO: Remove, We don't have Persuit team role anymore
    ) {
      let requiredStatusLength = 0;
      for (let i = 0; i < this.docMetaData.length; i++) {
        if (
          this.docMetaData[i].documentStatus === StatusEnum.RMReviewed ||
          this.docMetaData[i].documentStatus ===
            DocumentStatus.FinalArchiveReadyVersion
        ) {
          requiredStatusLength++;
        }
      }
      if (requiredStatusLength === 1) {
        if (
          item.documentStatus === StatusEnum.RMReviewed ||
          item.documentStatus === DocumentStatus.FinalArchiveReadyVersion
        ) {
          this.showToast();
          return;
        }
      }
    }

    this.progressIndicator.show();
    this.intakeDetailService
      .deleteDocument(item.submissionDocumentId)
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: () => {
          // TODO: document delete response are not calling so we have to call getDocumentMetaData here
          this.progressIndicator.hide();
          this.triggerDocAPIReload();
        },
        error: (err: HttpErrorResponse) => {
          this.progressIndicator.hide();
          this.triggerDocAPIReload();
          if (err?.status !== 200) {
            console.error('Error in delete document data', err);
          }
        },
      });

    // TODO: We can remove the below code as on data reload we will get updated data
    // this.docMetaData = this.docMetaData.filter(
    //   (doc: { submissionDocumentId: number }) =>
    //     doc.submissionDocumentId !== item.submissionDocumentId
    // );
    // this.docToShow = this.docToShow.filter(
    //   (doc: { submissionDocumentId: number }) =>
    //     doc.submissionDocumentId !== item.submissionDocumentId
    // );
    // this.#updateStatus();
    // this.documentTableData.emit(this.docToShow);
  }

  getDocumentMetaData(): void {
    if (this.submissionId && this.submissionId !== 0) {
      this.progressIndicator.show();
      this.intakeDetailService
        .getDocumentTableData(this.submissionId)
        .pipe(takeUntil(this.unsubscriber$))
        .subscribe({
          next: (data: IntakeDocumentTableModel[]) => {
            let apiResponse: IntakeDocumentTableModel[] = data;
            this.allDocFromAPI = data;
            const userNoAccesstoInternalRMDoc: boolean =
              this.loggedInUserRoles.every((role) =>
                this.downloadDisabledUserRolesForRMReviewedDocs.includes(role)
              );

            if (userNoAccesstoInternalRMDoc) {
              apiResponse = apiResponse.filter(
                (item: IntakeDocumentTableModel) =>
                  Number(item.documentStatusId) !==
                  IntakeDocumentStatusIdMapper.get(
                    DocumentStatus.InternalRMReviewed
                  )
              );
            }

            apiResponse = this.filterAPIDataBasedOnTableId(apiResponse);
            this.docMetaData = apiResponse.map(
              (item: IntakeDocumentTableModel) => ({
                ...item,
                isChecked: this.setItemCheckedStatus(item),
                isDisabled: this.diableArchiveIt(item.documentStatus),
                ariaLabel: item.documentTitle + ' checkbox',
                isVisible:
                  !item.archivalStatus &&
                  !this.submissionStatusCompletedOrCompletedAdmin,
                docArchiveStatus: this.getDocumentStatus(
                  item.archivalStatus ?? IntakeConstant.EMPTY_SPACE
                ),
                documentTypeId: Number(item?.documentTypeId) ?? 0,
                documentStatusId: Number(item?.documentStatusId) ?? 0,
              })
            );

            const hasRFP = this.docMetaData.some(
              (doc) => doc.documentType === IntakeConstant.DOC_TYPE
            );
            this.submissionService.setHasRFP(hasRFP);

            this.#updateStatus();
            if (this.filterDocArr.length > 0 && !this.showToggleBtn) {
              this.filterDocumentByDocStatus(this.filterDocArr);
            } else {
              this.filterDocumentData(this.toggleOpen);
            }
            this.checkDocumentStatus();
            this.disableDownloadButton(userNoAccesstoInternalRMDoc);
            this.documentTableData.emit(this.allDocFromAPI);
            this.progressIndicator.hide();
          },
          error: (err: HttpErrorResponse) => {
            this.progressIndicator.hide();
            console.error('Error in fetching document data', err);
          },
        });
    }
  }

  filterAPIDataBasedOnTableId(
    apiResponse: IntakeDocumentTableModel[]
  ): IntakeDocumentTableModel[] {
    if (
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.RM_REVIEWED_PENDING_CLOSEOUT ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.SELF_REVIEWED_PENDING_CLOSEOUT ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.INCOMPLETE_REVIEW_PENDING_CLOSEOUT
    ) {
      if (
        this.tableId === this.tableIdMapper['AccessReviewedTable'] ||
        this.tableId === this.tableIdMapper['ResubmitTable']
      ) {
        /*
         * For pendingcloseout, need to filter based on createdDate
         * Since we have toggle for AccessReviewedTable we need to filter the response and assign to docMetaData.
         * If we remove the toggle functionality for AccessReviewedTable, we can remove this for that table.
         *
         * We can skip it for ResubmitTable since we dont have a toggle in that table.
         */

        return apiResponse.filter((doc: IntakeDocumentTableModel) => {
          if (this.currentStatusChangeDate) {
            const comparison = compareDates(
              doc.createdDate,
              this.currentStatusChangeDate
            );

            return (
              this.currentStatusChangeDate &&
              (this.tableId === this.tableIdMapper['AccessReviewedTable']
                ? comparison === -1 || comparison === 0 // -1 -> doc created < statusChangeDate, 0 is equal
                : comparison === 1) // 1 -> doc created > statusChangeDate
            );
          }
          return false;
        });
      } else return apiResponse;
    } else return apiResponse;
  }

  checkDocumentStatus() {
    if (
      this.docToShow.every(
        (doc) => doc.documentStatus === IntakeConstant.DOCUMENT_STATUS
      )
    ) {
      this.allSelectedDocTypeSupporting = true; // Disable submit button
    } else {
      this.allSelectedDocTypeSupporting = false; // Enable submit button
    }
    this.intakeDetailService.updateIntakeSubmitBtnStatus(
      this.allSelectedDocTypeSupporting
    );
  }

  getDocumentStatus(archivalStatus: string): string {
    return archivalStatus != null
      ? String(archivalStatus).charAt(0).toUpperCase() +
          String(archivalStatus).slice(1)
      : IntakeConstant.EMPTY_SPACE;
  }

  setItemCheckedStatus(item: IntakeDocumentTableModel): boolean {
    if (
      item.isArchiveReady === null &&
      item.documentStatus === DocumentStatus.FinalArchiveReadyVersion
    ) {
      this.updateDocumentArchiveState(item, true);
    }
    return (
      item.isArchiveReady ||
      item.documentStatus === DocumentStatus.FinalArchiveReadyVersion ||
      !!item.isArchiveReady
    );
  }

  transformStatus(status: string): StatusEnum {
    return (
      Object.values(StatusEnum).find((enumValue) => enumValue === status) ||
      StatusEnum.Draft
    );
  }

  showToast(): void {
    this.toastService.createToast(this.toasteOption);
  }

  diableArchiveIt(docStatus: string): boolean {
    return docStatus === DocumentStatus.FinalArchiveReadyVersion;
  }

  updateRow(item: IntakeDocumentTableModel): void {
    if (!item.isDisabled) {
      this.docToShow = this.docToShow.map((doc) => ({
        ...doc,
        isChecked:
          doc.submissionDocumentId === item.submissionDocumentId
            ? (doc.isChecked = !doc.isChecked)
            : doc.isChecked,
      }));

      let selectedItem: IntakeDocumentTableModel | undefined =
        this.docToShow.find(
          (doc: IntakeDocumentTableModel) =>
            doc.submissionDocumentId === item.submissionDocumentId
        );
      if (selectedItem) {
        this.updateDocumentArchiveState(
          selectedItem,
          selectedItem.isChecked ?? false
        );
      }
    }
  }

  updateDocumentArchiveState(
    item: IntakeDocumentTableModel,
    isArchiveReady: boolean
  ): Promise<any> {
    const postRequestData = {
      submissionDocumentId: item.submissionDocumentId,
      submissionId: item.submissionId,
      documentTypeId: item.documentTypeId,
      documentStatusId: item.documentStatusId,
      submissionDocumentTypeId: item.submissionDocumentTypeId,
      documentTitle: item.documentTitle,
      comments: item.comments,
      isArchiveReady: isArchiveReady,
      modifiedBy: IntakeConstant.EMPTY_SPACE,
      attachmentId: item?.attachmentId,
    };
    return new Promise(() => {
      this.intakeDetailService
        .postDocumentEdit(postRequestData)
        .pipe(takeUntil(this.unsubscriber$))
        .subscribe({
          next: () => {},
          error: (err: HttpErrorResponse) => {
            console.error(
              'An error occurred during update document archive status:',
              err
            );
          },
        });
    });
  }

  disableDownloadButton(userRoleCondition: boolean): void {
    const submissionStatusCondition: boolean =
      this.submissionStatus === IntakeOppertunitySubmissionStatus.SUBMITTED ||
      this.submissionStatus === IntakeOppertunitySubmissionStatus.RESUBMITTED;

    if (submissionStatusCondition && userRoleCondition) {
      this.disabledDocumentIdList = this.docMetaData
        .filter(
          (doc: IntakeDocumentTableModel) =>
            doc.documentStatusId ===
              IntakeDocumentStatusIdMapper.get(DocumentStatus.RMReviewed) ||
            doc.documentStatusId ===
              IntakeDocumentStatusIdMapper.get(
                DocumentStatus.InternalRMReviewed
              )
        )
        .map((doc) => doc.submissionDocumentId);
    }
  }

  checkDocumentStatusEligiblity(submissionDocumentId: number): boolean {
    return this.disabledDocumentIdList.includes(submissionDocumentId);
  }

  disabledDownloadClickHandler(submissionDocumentId: number): void {
    if (this.disabledDocumentIdList.includes(submissionDocumentId)) {
      this.toastService.createToast({
        ...this.toasteOption,
        title: `Download functionality is not available during '${this.submissionStatus}' status.`,
      });
    }
  }

  triggerDocAPIReload(): void {
    this.intakeDetailService.triggerDocumentReload({
      sourceTableId: this.tableId,
      triggerScope: 'all',
    });
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }
}
